import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {Button} from "@nolimitcity/slot-game/bin/core/component/Button";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ReelEvent} from "@nolimitcity/slot-game/bin/core/reel/event/ReelEvent";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {GameSetting} from "@nolimitcity/slot-game/bin/core/setting/GameSetting";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {Power3, TweenLite} from "gsap";
import {CreepyCarnivalTwoGameConfig} from "../CreepyCarnivalTwoGameConfig";
import {CreepyCarnivalTwoSoundConfig} from "../CreepyCarnivalTwoSoundConfig";
import {CCTwoFreeSpinEntryEvents} from "../screen/freespinintro/CreepyCarnivalTwoFreespinIntroController";
import {CCTwoFreeSpinExitEvents} from "../screen/freespinoutro/CCTwoFreespinOutroController";
import {CreepyCarnivalTwoParsedGameData} from "../server/data/CreepyCarnivalTwoParsedGameData";
import {CCTwoStarSpinIntroEvents} from "../starspin/controller/StarSpinIntroController";
import {CreepyCarnivalBulbsEvent} from "../utils/CCTwoBulb";
import {CCTwoInitialWPEvents} from "../winpresentation/initial/CreepyCarnivalTwoInitialWPController";
import {DevKeyTriggerManager} from "@nolimitcity/slot-launcher/bin/devtools/DevKeyTriggerManager";

export class CCTwoStarMeter extends BaseView {
    private _layer:PIXI.Container;
    private _container_backGround:PIXI.Container = new PIXI.Container();
    private _container_foreGround:PIXI.Container = new PIXI.Container();
    private _container_button:Button;
    private _allContainers:PIXI.Container[] = [];
    private _starSpinText:PIXI.Text;
    private _starSpinCounterText:PIXI.Text;
    private _starSpinCounterSlash:PIXI.Text;
    private _starSpinTotalText:PIXI.Text;
    private _backGroundImage:PIXI.Sprite;
    private _rotatingStarImage:PIXI.Sprite;
    private _foreGroundImage:PIXI.Sprite;
    private _movingImage:PIXI.Sprite;
    private _movingImageDisabled:PIXI.Sprite;
    private _alphaImage:PIXI.Sprite;
    private _starMeterImage:PIXI.Sprite;
    private _starMeterImageDisabled:PIXI.Sprite;
    private _starMeterImageEnabled:PIXI.Sprite;
    private _starMeterAreaMask:PIXI.Graphics;
    private _totalNumberOfSymbols:number = 1;
    private _counter:number = 0;
    private _counterForAbort:number = 0;
    private _freeSpinMultiplier:number = 1;
    private _basGameMultiplier:number = 0;
    private _symbolsDifference:number = 0;
    private _isRestore:boolean = false;
    private _isPlayedOnce:boolean = false;
    private _isShown:boolean = false;
    private _spinStarted:boolean = false;
    private _backGroundFrame:PIXI.Sprite;
    private _starSpinLogo:PIXI.Sprite;
    private _gameMode:string = 'NORMAL';
    private _nextMode:string = 'NORMAL';
    private _slotApi:any;
    private _autoplay:any;
    private isResourcesLoaded :boolean =false;

    constructor() {
        super();

        this._layer = StageManager.getLayer(CreepyCarnivalTwoGameConfig.instance.LAYERS.STAR_METER.name);
        this._counter = 0;
        this._slotApi = SlotGame.api;
        this._autoplay = SlotGame.autoPlay;
        this._allContainers.push(this._container_backGround);
        this._allContainers.push(this._container_foreGround);
        this._allContainers.push(this._container_button);
        this._layer.addChild(this._container_backGround);
        this._layer.addChild(this._container_foreGround);
    }

    protected addEventListeners():void {
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onServerDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onServerDataParsed(event.params[0]));
        EventHandler.addEventListener(this, CCTwoInitialWPEvents.STAR_STATUS_SCREEN_HIDDEN, (event:GameEvent) => this.statusScreenHidden());
        EventHandler.addEventListener(this, ReelEvent.REEL_SPIN_STARTED, (event:GameEvent) => this.disableStarButton());
        EventHandler.addEventListener(this, ReelEvent.ALL_REELS_SPIN_STOPPED, (event:GameEvent) => this.enableStarButton());
        EventHandler.addEventListener(this, SpinEvent.IDLE, (event:GameEvent) => this.onIdle());
        EventHandler.addEventListener(this, CCTwoInitialWPEvents.STAR_ANIMATION_COMPLETED, (event:GameEvent) => this.onStarCollected(event.params[0]));
        EventHandler.addEventListener(this, CCTwoInitialWPEvents.DISPLAY_STAR_SPIN_LOGO, (event:GameEvent) => this.displayStarSpinLogo());
        EventHandler.addEventListener(this, CCTwoFreeSpinEntryEvents.ENTER_IN_FREE_SPIN, (event:GameEvent) => this.inFreeSpin());
        EventHandler.addEventListener(this, CCTwoFreeSpinExitEvents.OUT_OF_FREE_SPIN, (event:GameEvent) => this.outOfFreeSpin());
        EventHandler.addEventListener(this, CCTwoStarSpinIntroEvents.ENTER_IN_STAR_SPIN, (event:GameEvent) => this.enterInStarSpin());
        EventHandler.addEventListener(this, CCTwoStarSpinIntroEvents.EXIT_FROM_STAR_SPIN, (event:GameEvent) => this.exitFromStarSpin());
        EventHandler.addEventListener(this, CCTwoInitialWPEvents.WIN_PRESENTATION_ABORTED, (event:GameEvent) => this.presentationAborted(event.params[0]));
    }

    protected onIdle():void {
        setTimeout(() => {
            if(!this._spinStarted) {
                this._container_button.enabled = true;
            }
        }, 600);
    }

    protected initAnimations():void {
        let dropDownImage:PIXI.Sprite;
        dropDownImage = new PIXI.Sprite(GameResources.getTextures("assets/starMeterDropDown")[0]);

        this._backGroundFrame = new PIXI.Sprite(GameResources.getTextures("assets/star_bar")[0]);
        this._backGroundFrame.position.set(870, 68);
        this._backGroundFrame.anchor.set(0.5, 0.5);

        this._starSpinLogo = new PIXI.Sprite(GameResources.getTextures("assets/starspin_logo_glow")[0]);
        this._starSpinLogo.position.set(609, 51);
        this._starSpinLogo.anchor.set(0.5, 0.5);
        this._starSpinLogo.alpha = 0;

        this._backGroundImage = new PIXI.Sprite(GameResources.getTextures("assets/bar_blue")[0]);
        this._backGroundImage.position.set(897, 79);

        this._backGroundImage.anchor.set(0.5, 0.5);
        this._backGroundImage.scale.x = 0.48;
        this._backGroundImage.scale.y = 0.755;
        this._backGroundImage.alpha = 1;
        this._foreGroundImage = new PIXI.Sprite(GameResources.getTextures("assets/bar_green")[0]);
        this._foreGroundImage.position.set(897, 79);
        this._foreGroundImage.anchor.set(0.5, 0.5);
        this._foreGroundImage.scale.x = 0.48;
        this._foreGroundImage.scale.y = 0.755;
        this._foreGroundImage.alpha = 1;
        this._movingImage = new PIXI.Sprite(GameResources.getTextures("assets/win_glow")[0]);
        this._movingImage.position.set(788, 80);
        this._movingImage.anchor.set(0.5, 0.5);
        this._movingImage.alpha = 1;
        this._movingImage.scale.y = 1.2;
        this._movingImageDisabled = new PIXI.Sprite(GameResources.getTextures("assets/win_glow_blue")[0]);
        this._movingImageDisabled.position.set(788, 80);
        this._movingImageDisabled.anchor.set(0.5, 0.5);
        this._movingImageDisabled.alpha = 0;
        this._movingImageDisabled.scale.y = 1.2;
        this._alphaImage = new PIXI.Sprite(GameResources.getTextures("assets/win_glow")[0]);
        this._alphaImage.position.set(815, 75);
        this._alphaImage.anchor.set(0.5, 0.5);
        this._alphaImage.alpha = 0;
        this._starSpinCounterText = new PIXI.Text(this._counter.toString(), {
            fontFamily : 'Insane Rodeo Bold',
            fontSize : 30,
            fill : 0xdfcf53,
            align : 'right',
            fontWeight : 'bold'
        });
        this._starSpinCounterText.anchor.set(0.5, 0.5);
        this._starSpinCounterSlash = new PIXI.Text("/", {
            fontFamily : 'Arial',
            fontSize : 30,
            fill : 0xdfcf53,
            align : 'center',
            fontWeight : 'bold'
        });

        this._starSpinCounterSlash.anchor.set(0.5, 0.5);
        this._starSpinTotalText = new PIXI.Text("13", {
            fontFamily : 'Insane Rodeo Bold',
            fontSize : 30,
            fill : 0xdfcf53,
            align : 'left',
            fontWeight : 'bold'
        });

        this._starSpinTotalText.anchor.set(0.5, 0.5);


        dropDownImage.anchor.set(0.5, 0.5);

        let maskShape = new PIXI.Graphics();
        maskShape.beginFill(0xFFFFFF, 1);
        maskShape.drawRect(381, 65, 410, 30);
        maskShape.endFill();

        let mask = new PIXI.Graphics();
        mask.beginFill(0xFFFFFF, 1);
        mask.drawRect(792, 65, 210, 30);
        mask.endFill();

        if(this._starMeterAreaMask != null) {
            this.removeChild(this._starMeterAreaMask);
        }
        this._container_backGround.addChild(this._backGroundFrame);
        this._container_backGround.addChild(this._starSpinLogo);

        this._container_backGround.addChild(this._backGroundImage);
        this._container_backGround.addChild(this._foreGroundImage);
        this._starMeterAreaMask = maskShape;
        this._container_backGround.addChild(this._starMeterAreaMask);
        this._container_backGround.addChild(this._movingImage);
        this._container_backGround.addChild(this._movingImageDisabled);
        this._container_backGround.addChild(this._alphaImage);
        this._container_backGround.addChild(mask);
        this._movingImage.mask = mask;
        this._movingImageDisabled.mask = mask;
        this._backGroundImage.mask = this._starMeterAreaMask;
        this._foreGroundImage.mask = this._starMeterAreaMask;

        this._container_backGround.addChild(this._starSpinCounterText);
        this._container_backGround.addChild(this._starSpinCounterSlash);
        this._container_backGround.addChild(this._starSpinTotalText);
        this._container_backGround.addChild(dropDownImage);
        const textures = {
            idle : GameResources.getTextures("assets/bar_green")[0],
            over : GameResources.getTextures("assets/bar_green")[0],
            down : GameResources.getTextures("assets/bar_green")[0],
            disabled : GameResources.getTextures("assets/bar_green")[0]
        };
        this._container_button = new Button(textures, () => this.onStatusButtonClicked());
        this._container_button.position.set(897, 79);
        this._container_button.anchor.set(0.5, 0.5);
        this._container_button.scale.x = 0.48;
        this._container_button.scale.y = 0.755;
        this._container_button.alpha = 0;
        this._container_backGround.addChild(this._container_button);
        if(this._isRestore && (this._nextMode === "STAR_SPIN" || this._nextMode === "FREESPIN" || this._nextMode === "RESPIN_FREESPIN")) {
            this.disableStarButton();
        }

        this._starMeterImageDisabled = new PIXI.Sprite(GameResources.getTextures("assets/starspin_button_blue")[0]);
        this._starMeterImageDisabled.position.set(1045, 75);
        this._starMeterImageDisabled.anchor.set(0.5, 0.5);
        this._starMeterImageDisabled.scale.set(0.55);
        this._starMeterImageDisabled.alpha = 0;
        this._starMeterImageEnabled = new PIXI.Sprite(GameResources.getTextures("assets/starspin_button_lit")[0]);
        this._starMeterImageEnabled.position.set(1045, 75);
        this._starMeterImageEnabled.anchor.set(0.5, 0.5);
        this._starMeterImageEnabled.scale.set(0.55);
        //TODO: when assets will be updated by Gustav, update the following code for enabled light on star spin hit
        this._starMeterImageEnabled.alpha = 0;
        this._container_foreGround.addChild(this._starMeterImageDisabled);
        this._rotatingStarImage = new PIXI.Sprite(GameResources.getTextures("assets/star_shine")[0]);
        this._rotatingStarImage.position.set(1039, 75);
        this._rotatingStarImage.anchor.set(0.5, 0.5);
        this._rotatingStarImage.alpha = 0;
        this._container_foreGround.addChild(this._rotatingStarImage);
        this._starMeterImage = new PIXI.Sprite(GameResources.getTextures("assets/starspin_button")[0]);
        this._starMeterImage.position.set(1045, 75);
        this._starMeterImage.anchor.set(0.5, 0.5);
        this._starMeterImage.scale.set(0.55);
        this._container_foreGround.addChild(this._starMeterImageDisabled);
        this._container_foreGround.addChild(this._starMeterImage);
        this._container_foreGround.addChild(this._starMeterImageEnabled);
        this.isResourcesLoaded =true;
        //fix for #301
        if(this._freeSpinMultiplier === 5 ) { //if response not recieved by now..starmeter should be disabled on response recieved
            this.inFreeSpin();
        }
        this._container_backGround.position.set(21, -3);
        this._starSpinText = new PIXI.Text("STAR SPIN METER", {
            fontFamily : 'Insane Rodeo Bold',
            fontSize : 18,
            fill : "#4e2c11",
            align : 'center'
        });
        this._container_backGround.addChild(this._starSpinText);
        this._starSpinText.position.set(898, 47);
        this._starSpinCounterText.position.set(870, 77);
        this._starSpinCounterSlash.position.set(885, 80);
        this._starSpinTotalText.position.set(905, 77);
        dropDownImage.scale.set(0.6);
        dropDownImage.position.set(930, 80);
        this._movingImage.position.set(788, 80);
        this._starSpinText.anchor.set(0.5, 0.5);
        if(this._isRestore) {
            this.onStarCollected();
            this._isRestore = false;
        }
    }

    protected onResize(resizeData:IResizeData):void {
        if(resizeData.orientation === Orientation.PORTRAIT) {
            this._container_foreGround.scale.set(1.5, 1.5);
            this._container_backGround.scale.set(1.5, 1.5);
            this._container_backGround.x = -480; //-480//-51
            this._container_backGround.y = -51;
            this._container_foreGround.x = -520; //-480//-51
            this._container_foreGround.y = -40;
            this._starSpinLogo.visible = false;
        } else {
            this._starSpinLogo.visible = true;
            this._container_backGround.position.set(21, -3);
            this._container_foreGround.position.set(0, 0);
            this._container_foreGround.scale.set(1, 1);
            this._container_backGround.scale.set(1, 1);
        }
        this._backGroundFrame.scale.set(1, 1);
        this._backGroundFrame.position.set(870, 68);
        this._starMeterImage.scale.set(0.55);
        this._starMeterImageEnabled.scale.set(0.55);
        this._starMeterImageDisabled.scale.set(0.55);
        this._starMeterImage.position.set(1045, 75);
        this._starMeterImageDisabled.position.set(1045, 75);
        this._starMeterImageEnabled.position.set(1045, 75);

    }

    private statusScreenHidden():void {
        this._container_button.enabled = false;
        this._isShown = false;

        setTimeout(() => {
            if(!this._spinStarted) {
                this._container_button.enabled = true;
            }
        }, 800);

    }

    private onServerDataParsed(data:CreepyCarnivalTwoParsedGameData):void {
        this._counterForAbort = 0;
        this._gameMode = data.mode;
        this._nextMode = data.nextMode;
        this._isRestore = false;
        this._basGameMultiplier = data.multiplier;
        if(data.specialSymbolsLength) {
            this._totalNumberOfSymbols = data.specialSymbolsLength;
            this._counter = data.specialSymbolsLength;
            this.onGameInit();
            this._isRestore = true;
        }
        if(data.multiplier === 5 ) {
            this._freeSpinMultiplier = data.multiplier;
        }
        if(data.specialSymbolsLengthAfter > 0) {
            this._symbolsDifference = data.specialSymbolsLengthAfter - data.specialSymbolsLengthBefore;
        } else {
            this._symbolsDifference = 0;
        }
        if(this.isResourcesLoaded && data.multiplier==5){
            this.inFreeSpin();
            //if response is recieved after resources loaded ..
            // starmeter should be disabled on response recieved
            // fixing #301
        }
        this.isResourcesLoaded =false; //only required on resotre in FS for #301
    }

    private onGameInit():void {
        if(this._counter > 0 && this._starSpinCounterText) {
            this._starSpinCounterText.text = this._counter.toString();
            this._movingImage.alpha = 1;
            this._movingImage.x = this._movingImage.x + (210 / 13) * this._totalNumberOfSymbols;
            this._starMeterAreaMask.x = this._starMeterAreaMask.x + (210 / 13) * this._totalNumberOfSymbols;
            this._totalNumberOfSymbols = 1;
        }
    }

    private disableStarButton():void {
        this._spinStarted = true;
        this._container_button.enabled = false;
    }

    private enableStarButton():void {
        this._spinStarted = false;
    }

    private enterInStarSpin():void {
        let _this:any = this;
        TweenLite.to(_this._starMeterAreaMask, 1, {
            x : 0,
            onComplete : () => {
                _this._counter = 0;
                _this._starSpinCounterText.text = _this._counter.toString();
                _this._isPlayedOnce = false;
                _this._starMeterImage.alpha = 0;
                _this._starMeterImageEnabled.alpha = 0;
                _this._starMeterImageDisabled.alpha = 1;
                _this._movingImageDisabled.alpha = 1;
                _this._movingImage.alpha = 0;
                _this._movingImageDisabled.position.set(_this._movingImage.x, _this._movingImage.y);
            }
        });
        TweenLite.to(_this._movingImage, 1, {
            x : 788
        });
    }

    private exitFromStarSpin(isQuickStop?:boolean):void {
        if(this._gameMode === "STAR_SPIN") {
            let _this:any = this;
            // this._slotApi.betLevels.clearDisplayBetLevel();
            // this._slotApi.betLevels.unlock('CreepyCarnival');
            // this._slotApi.betLevels.update();

            // resetting following to their initial/default values
            this._movingImage.x = 788;
            this._starMeterAreaMask.x = 0;
            this._counter = 0;
            this._starSpinCounterText.text = this._counter.toString();
            if(this._nextMode !== "FREESPIN") {
                this._container_button.enabled = true;
            }
            let delay:number = 0.5;
            if(isQuickStop) {
                delay = 0.1;
            }
            TweenLite.to(_this._starMeterImageEnabled, delay, {
                alpha : 0
            });
            EventHandler.dispatchEvent(new GameEvent(CreepyCarnivalBulbsEvent.HIDE_STAR_SPIN_BULBS));
            SlotGame.sound.playEffect(CreepyCarnivalTwoSoundConfig.instance.SS_EXIT);
            TweenLite.to(_this._starSpinLogo, delay, {
                alpha : 0,
                onComplete : () => {
                    _this._starMeterImage.alpha = 1;
                    _this._starMeterImageEnabled.alpha = 0;
                    _this._starMeterImageDisabled.alpha = 0;
                    _this._movingImageDisabled.alpha = 0;
                    _this._movingImage.alpha = 1;
                }
            });
        }
    }

    private displayStarSpinLogo():void {
        let _this:any = this;
        TweenLite.to(_this._starSpinLogo, 1.5, {
            alpha : 1
        });
    }

    private wobbleImage():void {
        TweenLite.to(this._starMeterImage.scale, 0.2, {
            y : 0.5,
            ease : Power3.easeInOut,
            onComplete : () => {
                TweenLite.to(this._starMeterImage.scale, 0.15, {
                    y : 0.65,
                    ease : Power3.easeInOut,
                    onComplete : () => {
                        TweenLite.to(this._starMeterImage.scale, 0.1, {
                            y : 0.52,
                            ease : Power3.easeInOut,
                            onComplete : () => {
                                TweenLite.to(this._starMeterImage.scale, 0.1, {
                                    y : 0.6,
                                    ease : Power3.easeInOut,
                                    onComplete : () => {
                                        TweenLite.killTweensOf(this._starMeterImage);
                                    }
                                })
                            }
                        })
                    }
                })
            }
        });
    }

    public updateStarCounterAlt(data:CreepyCarnivalTwoParsedGameData){
        this.onServerDataParsed(data);
    }
    public updateStarCounter(count:number){
        if (this._counter != count){
            this._counter = count;
            this._counterForAbort = 0;
            let maskX:number = (210 / 13) * this._counter;
            let movingImageX:number = 788 + maskX;
            TweenLite.killTweensOf(this._starMeterAreaMask);
            TweenLite.killTweensOf(this._movingImage);
            this._starMeterAreaMask.x = maskX;
            this._movingImage.x = movingImageX;
            this._starSpinCounterText.text = this._counter.toString();
            this.checkStarShine();
        }
    }

    public onStarCollected(quickUpdate:boolean = false):void {
        if(this._totalNumberOfSymbols === 1 && !this._isRestore) {
            this.wobbleImage();
            this._counter += 1;
            this._counterForAbort += 1;
            this._movingImage.alpha = 1;
            let maskX:number = (210 / 13) * this._counter;
            let movingImageX:number = 788 + maskX;
            if(GameSetting.isFastSpin || quickUpdate) {
                /* fix 299 as tween was resetting the x of mask to counter before quickupdate;*/
                TweenLite.killTweensOf(this._starMeterAreaMask);
                TweenLite.killTweensOf(this._movingImage);
                this._starMeterAreaMask.x = maskX;
                this._movingImage.x = movingImageX;
            } else {
                TweenLite.to(this._starMeterAreaMask, 0.1, {x : maskX});
                TweenLite.to(this._movingImage, 0.1, {x : movingImageX});
            }

        } else {
            this._starMeterAreaMask.x = this._starMeterAreaMask.x + (210 / 13) * this._totalNumberOfSymbols;
            this._movingImage.alpha = 1;
            this._movingImage.x = this._movingImage.x + (210 / 13) * this._totalNumberOfSymbols;
            this._counter = this._totalNumberOfSymbols;
            this._totalNumberOfSymbols = 1;
        }
        this._starSpinCounterText.text = this._counter.toString();
        this.checkStarShine();
        if(!quickUpdate) {
            SlotGame.sound.playEffect(CreepyCarnivalTwoSoundConfig.instance.SS_COUNT_UP);
        }
    }

    private inFreeSpin():void {
        this._movingImageDisabled.x = this._movingImage.x;
        TweenLite.to(this._foreGroundImage, 0.5, {
            alpha : 0
        });
        TweenLite.to(this._movingImageDisabled, 0.5, {
            alpha : 1
        });
        TweenLite.to(this._movingImage, 0.5, {
            alpha : 0
        });
        TweenLite.to(this._starMeterImage, 0.5, {
            alpha : 0
        });
        TweenLite.to(this._starMeterImageEnabled, 0.5, {
            alpha : 0
        });
        TweenLite.to(this._starMeterImageDisabled, 0.5, {
            alpha : 1
        });
    }

    private presentationAborted(isQuickStop:boolean):void {
        if(isQuickStop && (this._gameMode === "NORMAL" || this._gameMode === "RESPIN_MAIN")) {
            TweenLite.killTweensOf(this._starMeterAreaMask);
            TweenLite.killTweensOf(this._movingImage);
            this._counter = this._counter + this._symbolsDifference - this._counterForAbort;
            this._starMeterAreaMask.x = this._starMeterAreaMask.x + ((210 / 13) * (this._symbolsDifference - this._counterForAbort));
            if(!this._movingImage.alpha) {
                this._movingImage.alpha = 1;
            }

            this._movingImage.x = this._movingImage.x + ((210 / 13) * (this._symbolsDifference - this._counterForAbort));
            this._starSpinCounterText.text = this._counter.toString();
            this._counterForAbort = 0;
            this.checkStarShine();
            this._totalNumberOfSymbols = 1;
        } else if(isQuickStop && this._gameMode === "STAR_SPIN") {
            this.exitFromStarSpin(isQuickStop);
        }
    }

    private checkStarShine():void {
        if(this._counter === 13 && !this._isPlayedOnce) {
            this._isPlayedOnce = true;
            this._rotatingStarImage.alpha = 1;
            this._starMeterImageEnabled.alpha = 1;
            SlotGame.sound.playEffect(CreepyCarnivalTwoSoundConfig.instance.SS_METER_FULL);
            TweenLite.to(this._rotatingStarImage, 0.5, {
                rotation : 30,
                onComplete : () => {
                    TweenLite.to(this._rotatingStarImage, 0.2, {
                        alpha : 0
                    });
                    TweenLite.to(this._rotatingStarImage, 1, {
                        rotation : 0
                    });
                }
            });
        }
    }

    private outOfFreeSpin():void {
        TweenLite.to(this._foreGroundImage, 0.5, {
            alpha : 1
        });
        TweenLite.to(this._movingImageDisabled, 0.5, {
            alpha : 0
        });
        TweenLite.to(this._movingImage, 0.5, {
            alpha : 1
        });
        TweenLite.to(this._starMeterImage, 0.5, {
            alpha : 1
        });
        if(this._counter === 13) {
            this._starMeterImageEnabled.alpha = 1;
        }
        TweenLite.to(this._starMeterImageDisabled, 0.5, {
            alpha : 0
        });
        this._container_button.enabled = true;
    }

    private onStatusButtonClicked():void {
        this._container_button.enabled = false;
        setTimeout(() => {
            if(!this._spinStarted) {
                this._container_button.enabled = true;
            }
        }, 800);
        if(!this._isShown) {
            EventHandler.dispatchEvent(new GameEvent(CCTwoInitialWPEvents.DISPLAY_STATUS_SCREEN));
            this._isShown = true;
        } else {
            EventHandler.dispatchEvent(new GameEvent(CCTwoInitialWPEvents.HIDE_STATUS_SCREEN));
            this._isShown = false;
        }
    }
}